module.exports = __webpack_public_path__ + "images/1cc642c65f8abd7f9d1015ef1762e38fb.svg";